export default "__VITE_ASSET__BLOu5IHX__"